import { OktaAuth } from "@okta/okta-auth-js";
import { resolveVariable } from "../utils/config.utils";
const config = Object.freeze({
    okta: {
        clientId: resolveVariable("OKTA_CLIENT_ID", "FAKE_CLIENT_ID"),
        issuer: resolveVariable("OKTA_ISSUER", "https://dev-auth.moodys.com/oauth2/default"),
    },
});
export const oktaAuth = new OktaAuth({
    ...config.okta,
    redirectUri: window.location.origin,
    pkce: true,
    scopes: ["openid", "email", "profile", "offline_access", "mdcapp"],
    tokenManager: {
        autoRenew: true,
        autoRemove: true,
        storage: "localStorage",
    },
});
//# sourceMappingURL=oktaAuthProvider.js.map